import type { SkeletonProps } from './Skeleton.types'

export function Skeleton({ className = '' }: SkeletonProps) {
    return (
        <div
            className={`animate-pulse motion-reduce:animate-none bg-gray-200 dark:bg-white/10 rounded ${className}`}
        />
    )
}
